module.exports = __webpack_public_path__ + "img/bart.a60f92e1.png";